<template lang="pug">
div
  .row
    .register-form
      .d-flex.flex-row
        a.logo(href="")
          img(src="@/assets/images/xendity-logo.png", alt="")
        .d-flex.flex-row.tag-groups
          span.mr-4 SECURE
          span.mr-4 &#183;
          span.mr-4 IMMUTABLE
          span.mr-4 &#183;
          span.mr-4 IRREFUTABLE
      .py-5
        h1 Reset your account password
        h6.mb-5 If you did not receive e-mail, key in username and request resend
        div
          .form-row.mb-4
            .col
              input#exampleInputUsername.form-control(
                type="text",
                placeholder="Enter username",
                v-model="$v.username.$model"
              )
              small.text-danger.my-1.ml-4(
                v-if="$v.username.$dirty && !$v.username.required"
              ) Username is required.
              small.text-danger.my-1.ml-4(
                v-if="$v.username.$dirty && !$v.username.minLength"
              ) Username must be more than 5 characters.
              small.text-danger.my-1.ml-4(
                v-if="$v.username.$dirty && !$v.username.maxLength"
              ) Username cannot be more than 20 characters.
              small.text-danger.my-1.ml-4(
                v-if="$v.username.$dirty && !$v.username.alphaNumAndDotValidator"
              ) Only alpha numeric is allowed.
          .form-row.mb-4
            .col
              input#inputPassword.form-control(
                type="password",
                placeholder="Password",
                v-model="$v.password.$model"
              )
              small.text-danger.my-1.ml-4(
                v-if="$v.password.$dirty && !$v.password.required"
              ) Password is required.
              small.text-danger.my-1.ml-4(
                v-if="$v.password.$dirty && !$v.password.minLength"
              ) Password must be more than 5 characters.
          .form-row.mb-4
            .col
              input#confirmPassword.form-control(
                type="password",
                aria-describedby="passwordHelp",
                placeholder="Confirmation Password",
                v-model="$v.repeatPassword.$model"
              )
              small.text-info.my-1.ml-4(v-if="!$v.repeatPassword.$dirty") Make sure the passwords input are the same.
              small.text-danger.my-1.ml-4(
                v-if="$v.repeatPassword.$dirty && !$v.repeatPassword.required"
              ) Confirmation password is required.
              small.text-danger.my-1.ml-4(
                v-if="$v.repeatPassword.$dirty && !$v.repeatPassword.sameAsPassword"
              ) Confirmation password must be the same as password.
          button.btn.btn-blue.mb-5(@click="reset") Reset Password
          button.btn.btn-transparent.ml-3.mb-5(@click="resend") Resend Password Reset E-mail
      div
        p.disclaimer We will occasionally email you about Xendity’s products and features but, if you would rather not receive these email, please <a href="">click here</a> to unsubscribe.
        p.disclaimer By register you agree to our <a href="">Terms of Service, Privacy Policy</a>.
    img(width="35%", src="@/assets/images/register-banner.jpg", alt="")
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  sameAs,
  helpers,
} from "vuelidate/lib/validators";
const alphaNumAndDotValidator = helpers.regex(
  "alphaNumAndDot",
  /^[a-z\d._]*$/i
);

export default {
  mixins: [validationMixin],
  data() {
    return {
      username: "",
      password: "",
      repeatPassword: "",
      token: "",
    };
  },
  validations: {
    username: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(20),
      alphaNumAndDotValidator,
    },
    password: { required, minLength: minLength(6) },
    repeatPassword: {
      required,
      sameAsPassword: sameAs(function () {
        return this.password;
      }),
    },
  },
  mounted() {
    if (this.$route.query.token) this.token = this.$route.query.token;
    else
      this.$swal(
        "Password Reset Token Not Found",
        "Please use the correct link sent to your e-mail",
        "error"
      ).then((result) => {
        if (result.isConfirmed) {
          this.$router.push("/auth?mode=login");
        }
      });
  },
  methods: {
    reset() {
      this.$v.$touch();

      if (this.$v.$invalid) return;
      this.$store
        .dispatch("user/reset", {
          username: this.username,
          password: this.repeatPassword,
          token: this.token,
        })
        .then((response) => {
          if (response.status == 400)
            this.$swal(response.error_message, "Error", "error");
          else {
            this.$swal(
              response.message,
              "Password reset successful. You may login again.",
              "success"
            ).then((result) => {
              if (result.isConfirmed) {
                this.$router.push("auth?mode=login");
              }
            });
          }
        });
    },
    resend() {
      this.$v.username.$touch();

      if (this.$v.username.$error) return;
      this.$store
        .dispatch("user/request", {
          username: this.username,
        })
        .then((response) => {
          if (response.status == 400)
            this.$swal(response.error_message, "Error", "error");
          else {
            this.$swal(
              response.message,
              "Password reset request successful. Please check your e-mail.",
              "success"
            );
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/auth.scss";
</style>